import SocialLoginForm from './SocialLoginForm';
export default SocialLoginForm;